<template>
  <div class="shorturl">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>短链接生成器</span>
      </div>

      <el-input
        v-model="longUrl"
        placeholder="输入要缩短的长链接，如：https://example.com/very/long/url/path"
        clearable
        @input="onUrlInput"
        style="margin-bottom: 20px"
      >
        <template slot="prepend">URL</template>
      </el-input>
      
      <el-button type="primary" @click="generateShortUrl" :loading="loading">生成短链接</el-button>

      <div v-if="shortUrl" class="result-section">
        <el-divider></el-divider>
        <div class="short-url-display">
          <span class="label">短链接：</span>
          <el-link type="primary" :href="shortUrl" target="_blank" class="url-value">{{ shortUrl }}</el-link>
          <el-button size="small" type="success" @click="copyShortUrl" style="margin-left: 10px">复制</el-button>
        </div>
      </div>

      <el-divider></el-divider>

      <h3>历史记录</h3>
      <el-table :data="history" style="width: 100%" stripe>
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="shortUrl" label="短链接" width="200">
          <template slot-scope="scope">
            <el-link type="primary" :href="scope.row.shortUrl" target="_blank">{{ scope.row.shortUrl }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="longUrl" label="原始链接" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createdAt" label="创建时间" width="180"></el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="copyToClipboard(scope.row.shortUrl)">复制</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { generateShortUrl, listShortUrls } from '../api/shorturl'

export default {
  name: 'shorturl',
  data () {
    return {
      longUrl: '',
      shortUrl: '',
      loading: false,
      history: []
    }
  },
  mounted () {
    this.loadHistory()
  },
  methods: {
    onUrlInput (value) {
      console.log('URL输入值:', value, '| longUrl:', this.longUrl)
    },
    generateShortUrl () {
      if (!this.longUrl) {
        this.$message.warning('请输入长链接')
        return
      }
      this.loading = true
      // 确保发送正确格式的数据
      const params = { url: this.longUrl }
      console.log('发送请求，参数:', params)
      generateShortUrl(params).then(res => {
        console.log('响应:', res)
        // 注意：response.data 才是后端返回的数据
        const response = res.data || res
        if (response.success === false) {
          this.$message.error(response.message || '生成失败')
          return
        }
        this.shortUrl = response.data
        this.$message.success('生成成功!')
        this.loadHistory()
      }).catch((err) => {
        console.error('请求错误:', err)
        this.$message.error('生成失败: ' + (err.message || '未知错误'))
      }).finally(() => {
        this.loading = false
      })
    },
    loadHistory () {
      listShortUrls().then(response => {
        this.history = response.data || []
      }).catch(() => {
        // 静默处理
      })
    },
    copyShortUrl () {
      this.copyToClipboard(this.shortUrl)
    },
    copyToClipboard (text) {
      this.$copyText(text).then(() => {
        this.$message.success('已复制到剪贴板')
      }).catch(() => {
        const textarea = document.createElement('textarea')
        textarea.value = text
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        this.$message.success('已复制到剪贴板')
      })
    }
  }
}
</script>

<style scoped>
.shorturl {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}
.box-card {
  max-width: 1400px;
  margin: 0 auto;
}
.result-section {
  margin-top: 20px;
}
.short-url-display {
  display: flex;
  align-items: center;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 8px;
}
.label {
  font-weight: bold;
  margin-right: 10px;
}
.url-value {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/view/shorturl.vue